export type VoivodeshipId =
  | 'dolnoslaskie'
  | 'kujawsko-pomorskie'
  | 'lodzkie'
  | 'lubelskie'
  | 'lubuskie'
  | 'malopolskie'
  | 'mazowieckie'
  | 'opolskie'
  | 'podkarpackie'
  | 'podlaskie'
  | 'pomorskie'
  | 'slaskie'
  | 'swietokrzyskie'
  | 'warminsko-mazurskie'
  | 'wielkopolskie'
  | 'zachodniopomorskie';

export const VOIVODESHIP_NAMES: Record<VoivodeshipId, string> = {
  dolnoslaskie: 'Dolnośląskie',
  'kujawsko-pomorskie': 'Kujawsko-Pomorskie',
  lodzkie: 'Łódzkie',
  lubelskie: 'Lubelskie',
  lubuskie: 'Lubuskie',
  malopolskie: 'Małopolskie',
  mazowieckie: 'Mazowieckie',
  opolskie: 'Opolskie',
  podkarpackie: 'Podkarpackie',
  podlaskie: 'Podlaskie',
  pomorskie: 'Pomorskie',
  slaskie: 'Śląskie',
  swietokrzyskie: 'Świętokrzyskie',
  'warminsko-mazurskie': 'Warmińsko-Mazurskie',
  wielkopolskie: 'Wielkopolskie',
  zachodniopomorskie: 'Zachodniopomorskie',
};

export const isVoivodeshipId = (value: string): value is VoivodeshipId =>
  Object.prototype.hasOwnProperty.call(VOIVODESHIP_NAMES, value);

export type DealerCategory = 'all' | 'horeca';

export const DEALER_CATEGORY_LABELS: Record<DealerCategory, string> = {
  all: 'Kasoterminale dla wszystkich branż',
  horeca: 'Kasoterminale dla branży HoReCa (gastronomia, hotele, catering)',
};

export const isDealerCategory = (value: string): value is DealerCategory =>
  Object.prototype.hasOwnProperty.call(DEALER_CATEGORY_LABELS, value);

export interface Dealer {
  id: string;
  title: string;
  voivodeship: VoivodeshipId;
  detail: string;
  categories: DealerCategory[];
}

export type DealersByVoivodeship = Partial<Record<VoivodeshipId, Dealer[]>>;
